import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';
import { NomenclatureItemService } from '@zaoblako/web/core/services/finance/nomenclature-item.service';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { NomenclatureTypeNamePipe } from '@zaoblako/web/shared/pipes/nomenclature-type-name.pipe';

@Component({
  standalone: true,
  selector: 'crm-nomenclature-item-auto-complete',
  templateUrl: './nomenclature-item-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent, NomenclatureTypeNamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NomenclatureItemAutoCompleteComponent {
  @Input() public selectedNomenclature: NomenclatureItemFindInterface;
  @Output() public selectedNomenclatureChange = new EventEmitter<NomenclatureItemFindInterface>();

  @Input() public nomenclatures: NomenclatureItemFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public field = 'name';
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public showClear = false;

  @Input() public excludeIds: number[] = [];
  @Input() public customSearch = true;
  @Output() public nomenclatureSearch = new EventEmitter<string>();

  public constructor(
    private readonly nomenclatureService: NomenclatureItemService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toNomenclature(nomenclature: any): NomenclatureItemFindInterface {
    return nomenclature as NomenclatureItemFindInterface;
  }

  public searchNomenclature(name: string): void {
    this.nomenclatureService
      .find<NomenclatureItemFindInterface>({
        search: name,
        excludeIds: this.excludeIds
      })
      .subscribe((nomenclatures: NomenclatureItemFindInterface[]) => {
        this.nomenclatures = nomenclatures;
        this.cdRef.markForCheck();
      });
  }
}
